import { Subject } from "rxjs";
import { AbstractShape } from "../abstract/Shape";
import { DataViewer } from "../abstract/DataViewer";

export class ShapeRefArray {
    shape: AbstractShape[] = [];
    shapeSubject: Subject<AbstractShape> = new Subject();
    dataViewer: DataViewer | null;

    constructor(dataViewer: DataViewer | null){
        this.dataViewer = dataViewer;
    }

    addShape(shape: AbstractShape){
        if(!shape){
            return;
        }
        this.shapeSubject.next(shape);
        this.shape = [...this.shape, shape];
    }

    getShape(){
        return this.shape;
    }

    resetList(){
        for (const shape of this.shape) {
            shape.setFocus(false);
        }
        this.shape = [];
        if(this.dataViewer) this.dataViewer.draw();
    }

    setShapes(shape: AbstractShape[]){
        this.shapeSubject.next(shape[0]);
        this.shape = shape
    }

    removeShape(shape: AbstractShape){
        this.shape = this.shape.filter(s => s !== shape);
    }
}